// Get configuration from window.ENV (loaded from config.js) or import.meta.env for local development
export const getConfig = (key: string): string => {
  return (window as any).ENV?.[key] || import.meta.env[key] || '';
};

export const API_URL = getConfig('VITE_API_URL') || 'http://localhost:7072';
export const GOOGLE_MAPS_API_KEY = getConfig('GOOGLE_MAPS_API_KEY');